module.exports = __webpack_public_path__ + "static/media/Img-Login.43ea0565.png";